import React from 'react';
import ChallengeResources from '@/src/components/challenges/challengeDetailSections/challengeCFNTemplate/ChallengeResources';

export const ChallengeResourcesPage: React.FC = () => {
  return <ChallengeResources />;
};
